import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";

export default function PaymentOrderReport() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("exportar reporte orden de pago") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Descargar Órdenes"
              subtitle="Descargar reporte de órdenes de pago en formato TXT o Excel"
              icon={<DownloadRoundedIcon />}
              color="#10b981"
              to="/paymentOrder/report/txt"
            />
          </Grid>
        )}

        {hasPermission("exportar reporte orden de pago") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Reporte de Retenciones"
              subtitle="Generar ZIP con el comprobante PDF de cada orden por rango de fechas y cliente"
              icon={<PictureAsPdfRoundedIcon />}
              color="#e11d48"
              to="/paymentOrder/report/retentions"
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
